<div [ngStyle]="customStyle" *ngIf="label" class="vertical-center">
  <span>{{ label }}</span>
</div>
